/**
 *
 *
 *
 *
 *
 *
 *
 */
import { o_util } from "@gr-common/async/namespaces";
import { otto } from "@gr-exports/async/nexus";
import { asExport } from "@gr-exports/async/core";
import { noop } from "@gr-common/async/function";
/**
 *
 *
 *
 *
 */
export const onex = asExport(o_util, "onex", {});
/**
 *
 *
 *
 */
export const isOnexVariant = asExport(onex, "isOnexVariant", noop);
/**
 *
 *
 *
 */
export const mapOnexVariant = asExport(onex, "mapOnexVariant", noop);
/**
 *
 *
 *
 *
 */
export const withOnex = asExport(onex, "withOnex", noop);
/**
 *
 *
 */
export const customAssignments = asExport(onex, "customAssignments", noop);
/**
 *
 */
export const onexAsync = asExport(otto, "onex", {});
/**
 *
 *
 */
export const assignments = asExport(onexAsync, "assignments", {});
